<template>
  <div class="container py-5">
    <div class="row">
      <div class="col-md-8">
        <div class="vv-book">
          <div class="vv-book-header">
            <Headers></Headers>
            <!-- {{payplakey}} -->
            <div>
              <a-steps :current="current">
                <a-step
                  v-for="item in steps"
                  :key="item.title"
                  :disabled="true"
                  :title="item.title"
                />
              </a-steps>
              <div class="steps-content my-4">
                <component
                  :is="steps[current].content"
                  :paypal="paypalkey"
                  :dataContact="current == 1 ? current : null"
                  :price="255"
                />
              </div>
              <div class="steps-action text-end">
                      <div>
                  <button
                    v-if="current > 0"
                    style="margin-left: 8px"
                    @click="prev"
                    ><i class="bi bi-arrow-left"></i> Previous</button
                  >
                </div>
                <div v-if="current >= 1 || $store.state.ListRooms.length>0">
                  <button
                    v-if="current < steps.length - 1"
                    type="primary"
                    @click="next"
                    >Next <i class="bi bi-arrow-right"></i></button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Col ASIDE     BOOKING -->
      <div class="col-md-4">
        <aside class="book-sumary">
          <div class="book-sumary-content">
            <h2>YOUR STAY</h2>
            <div class="v-book-sumary">
              <div class="v-book-sumary-dates">
                <div class="v-book-sumary-dates-title">
                  <b><span>Check-in</span></b>
                  <span class="v-val">{{ $store.state.Details.Check_in }}</span>
                </div>
                <div class="v-book-sumary-dates-title">
                  <b><span>Check-out</span></b>
                  <span class="v-val">{{
                    $store.state.Details.Check_out
                  }}</span>
                </div>
              </div>
              <div class="mt-2 v-list-pass">
                <span>{{ $store.state.Details.adults }} Adults </span>
                <span v-if="$store.state.Details.children > 0"
                  >, {{ $store.state.Details.children }} Children</span
                >
              </div>
              <div class="mt-1 v-list-pass">
                <span class="mt-1" v-if="$store.getters.NumDays > 0"
                  >{{ $store.getters.NumDays }} Night
                </span>
              </div>
              <div class="v-sumary-rooms">
                <div
                  class="v-sumary-rooms-list border"
                  v-for="(room, index) in ListRooms"
                  :key="index"
                >
                  <div class="d-flex justify-content-between">
                    <div class="v-sumary-rooms-list-items">
                      {{ room.title.rendered }}
                    </div>
                    <div class="v-sumary-rooms-list-items">
                      <span
                        ><b>${{ room.acf.price }}.00</b> x
                        {{ $store.getters.NumDays }} Night</span
                      >
                    </div>
                  </div>
                  <button
                    class="btn btn-danger-outline btn-sm"
                    @click="DeleteRooms(index)"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>
              <hr />
                <!-- <div class="d-flex justify-content-between">
                
                <h6><b>IGV:</b></h6>
                <h6>
                    <b>${{ $store.state.igv }}:00</b>
                </h6>
              </div> -->
                <div class="d-flex justify-content-between">
                
                <h6><b>Total:</b></h6>
                <h6>
                    <b>${{ $store.state.subtotal }}:00</b>
                </h6>
              </div>
              <div class=" d-none d-flex justify-content-between">

                <h6><b>Total:</b></h6>
                <h6>
                    <b>${{ totalprice }}:00</b>
                </h6>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "Vuex";

import { reactive, computed, ref, toRefs } from "Vue";
import Headers from "./CheckDate.vue";
import Rooms from "./ListRooms.vue";
import First from "./First.vue";
import Second from "./Second.vue";
import Last from "./Last.vue";
import { message } from "ant-design-vue";
const key = "updatable";
export default {
  components: {
    Rooms,
    First,
    Second,
    Last,
    Headers,
  },
  props: {
    price: Number,
    tours: String,
    paypalkey: String,
  },
  setup(props) {
    const prop = toRefs(props);
    const store = useStore();
    const ListRooms = computed(() => store.state.ListRooms); //list Rooms
    const totalprice = computed(() => store.getters.TotalPrice); //toal price calc
    const current = computed(() => store.state.current); //current steps
    const Details = computed(() => store.state.Details); ////details
    const toggle = ref(false);
    const closeToggle = () => {
      toggle.value = false;
      console.log(toggle.value);
    };
    const loading = ref(false);

    const next = () => {

      message.loading({
        content: "Loading...",
        key,
      });
      //  validate steps one
      if (store.state.current == 0 &&store.state.Details.Check_in && store.getters.NumDays > 0) {
        setTimeout(() => {
          store.dispatch("plusCurrent");
        }, 2000);
      }
       if (store.state.current != 0 && store.state.Details.Check_in=="" && store.getters.NumDays < 0) {
         message.error({
                content: "select the check-in and check-out date!",
                key,
                duration: 2,
              });
          }
      if (store.state.current == 1 && validateform(store)) {
        setTimeout(() => {
          store.dispatch("plusCurrent");
        }, 2000);
      }
       if (store.state.current == 1 && !validateform(store)) {
       setTimeout(() => {
          message.error({
            content:
                 "Fill in the required fields",
            key,
            duration: 2,
          });
        }, 1000);
       }
      // else {
      //   setTimeout(() => {
      //     message.error({
      //       content:
      //         store.state.current == 1
      //           ? "Fill in the required fields"
      //           : "select the check-in and check-out date!",
      //       key,
      //       duration: 2,
      //     });
      //   }, 1000);
      // }
      //  validate steps one
    };
    const prev = () => {
      store.dispatch("minCurrent",{clearrom:0});
    };
    const DeleteRooms = (index) => {
      store.dispatch("deleteListRooms", index);
      console.log(store.state.ListRooms.length);
      if (store.state.ListRooms.length == 0) {
        store.dispatch("minCurrent", { clearrom: true });
      }
    };
    const validateform = (data) => {
      let val = false;
      if (
        data.state.Contact.first_name &&
        data.state.Contact.last_name &&
        data.state.Contact.email &&
        data.state.Contact.term
      ) {
        val = true;
      }

      return val;
    };

    return {
      ListRooms,
      totalprice,
      DeleteRooms,
      loading,
      message,
      current,
      steps: [
        {
          title: "Rooms",
          content: First,
        },
        {
          check:store.state.ListRooms.length,
          title: "Guest Details",
          content: Second,
        },
        {
          title: "Confirmation",
          paypal: prop.payplakey,
          content: Last,
        },
      ],
      next,
      prev,
    };
  },
};
</script>
